<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25 footer-text">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <span class="text-bold"> Talleres Pascual Mata Carda </span>
    </span>
    <span class="float-md-right d-block d-md-inline-block mt-25 footer-text">
      Version 1.3.3
    </span>
  </p>
</template>

<script>
export default {};
</script>
